// extracted by mini-css-extract-plugin
export default {"cover":"Fq1hlj","thumbContainer":"mdGBQR","thumbWrapper":"ZHR2PW"};